var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { RendererFactory } from "survey-core";
import { SurveyQuestionDropdownBase } from "./dropdown-base";
import { ReactQuestionFactory } from "./reactquestion_factory";
var SurveyQuestionButtonGroupDropdown = /** @class */ (function (_super) {
    __extends(SurveyQuestionButtonGroupDropdown, _super);
    function SurveyQuestionButtonGroupDropdown(props) {
        return _super.call(this, props) || this;
    }
    SurveyQuestionButtonGroupDropdown.prototype.renderElement = function () {
        var cssClasses = this.question.cssClasses;
        var select = this.renderSelect(cssClasses);
        return (React.createElement("div", { className: this.question.cssClasses.rootDropdown }, select));
    };
    return SurveyQuestionButtonGroupDropdown;
}(SurveyQuestionDropdownBase));
export { SurveyQuestionButtonGroupDropdown };
ReactQuestionFactory.Instance.registerQuestion("sv-buttongroup-dropdown", function (props) {
    return React.createElement(SurveyQuestionButtonGroupDropdown, props);
});
RendererFactory.Instance.registerRenderer("buttongroup", "dropdown", "sv-buttongroup-dropdown");
